var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Theo dõi trực tiếp","link":[
          {
            text: 'Xe tuyến',
            href: '../busList'
          }
        ]}})],1)]),(_vm.role.type !== 'buslist')?_c('v-card',{staticClass:"pa-6 mx-4 mb-6 elevation-0",attrs:{"outlined":""}},[_c('BusTrackingFilter',{on:{"onFilterChanged":_vm.refresh}})],1):_vm._e(),_c('v-card',{staticClass:"mx-4 elevation-0",attrs:{"outlined":""}},[_c('BusTrackingMap',{attrs:{"query":_vm.query}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }